// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__wcxiG","icon":"Search_icon__bhu8D","opened":"Search_opened__Lde7H"};